export const CAKE_BNB_LP_MAINNET = '0xD87b639850FC88b6F616a6CDBcDaFD345022CE6E'
